/*
 * All concerns for how Google API(s) are used from the client.
 *
 * 1.) File Picker for Google Sheets import connections
 *
 * Usage:
 *
 *  import googleApi from 'scoreboard/components/google-api'
 *  googleApi.launchFilePicker(credential.accessToken).then(result => {
 *      // do something with the result here
 *  })
 *
 */

import $ from 'jquery'

import _ from 'lodash'
import Backbone from 'backbone'
import globals from 'scoreboard/components/globals'
import license from 'scoreboard/components/license'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'

let fileKey, authEndpoint, clientId // Provider attributes
let orbBase
Backbone.on('load', ({orbProviders = {}, orbPublicEndpoint}) => {
	orbBase = orbPublicEndpoint
	const providerData = _.find(orbProviders, {provider: 'google'})
	if (providerData) {
		authEndpoint = providerData.authEndpoint
		clientId = providerData.clientId
		fileKey = _.get(providerData, `developerKeys['file']`)
	}
})

const googleApi = {

	/**
	 * @returns {boolean} True if there is a google provider configured with
	 * an Google API Key for the File Picker.
	 */
	isAvailable: function() {
		return !_.isNil(orbBase) && !_.isNil(fileKey)
	},

	buildGoogleOAuthUrl: function() {
		const scopes = [
			'https://www.googleapis.com/auth/drive.readonly',
			'https://www.googleapis.com/auth/userinfo.email'
		]

		/*
			The Oauth redirect can't be authorized with an apiToken, and consequently
			the license information can't be derived from the token when google
			redirects to the Orb endpoint.

			So, customerId is constructed here and passed in the state parameter.

			Any subsequent requests to retrieve the connection WILL be authorized
			by the apiToken and only connection records matching the license
			that corresponds to the apiToken will be returned.
		 */
		// This is a required format: [licensee_label].[licenseId].[databaseUUID]
		const impactCustomerId = `${_.snakeCase(license.label)}.${license.id}.${globals.database.uuid}`
		const provider = 'google'
		const scoreboardRedirect = scoreboardUrl('admin/third-party-connection')
		const redirect_uri = `${orbBase}/oauth-redirect`
		const params = {
			access_type: `offline`,
			response_type: `code`,
			prompt: 'consent', // So we always get a refresh token
			redirect_uri,
			// Orb needs all these things to redirect back here (fnOAuthRedirect.js in spider-aws-orb)
			state: [impactCustomerId, provider, scoreboardRedirect, redirect_uri].join('|'),
			client_id: clientId,
			scope: scopes.join(' ')
		}
		return `${authEndpoint}?` + $.param(params)
	}
}

export default googleApi
googleApi.__filename__ = 'components/google-api.js'
